export const stripFormatting = (value: string | number = ''): number => {
  if (typeof value === 'number') {
    return value;
  }

  const parsedValue = parseFloat(value.replace(/[^0-9.]/g, ''));
  return Number.isNaN(parsedValue) ? 0.0 : parsedValue;
};

export const formatInputToCurrency = (value: string | number): string => {
  const number = stripFormatting(value);

  if (Number.isNaN(number)) {
    return '';
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(number);
};
